import PropTypes from 'prop-types'

/**
 * @typedef {Object} InvoiceNotificationEmailAddress
 * @property {string}   [invoiceNotificationEmailAddressId] - The identifier of the email address
 * @property {string}   [emailAddress]                      - The email address
 * @property {boolean}  [verified]                          - Flag indicating if the email address is verified
 */
export const invoiceNotificationEmailAddressPropType = PropTypes.shape({
    emailAddress: PropTypes.string,
    invoiceNotificationEmailAddressId: PropTypes.string,
    verified: PropTypes.bool
})
